import { Action } from '@ngrx/store';

export const UPDATE_LINK = '[App] Update link';
export const GOTO_MAIN = '[App] Goto main';
export const GOTO_BACK = '[App] Goto back';

export class UpdateLinkAction implements Action {
  readonly type = UPDATE_LINK;

  constructor() {}
}

export class GotoMainAction implements Action {
  readonly type = GOTO_MAIN;

  constructor() {}
}

export class GotoBackAction implements Action {
  readonly type = GOTO_BACK;

  constructor() {}
}

export type Actions
  = UpdateLinkAction
  | GotoMainAction
  | GotoBackAction;



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/store.module/app.actions.ts